export const getTotalPercentage = (total, count) => {
    if (total === 0 || count === 0) {
        return 0;
    }
    const totalPercentage = (count * 100) / total;
    if (Number.isInteger(totalPercentage)) {
        // If it's an integer, return it as is
        return totalPercentage;
    } else {
        // If it has decimal places, round it to 2 decimal places
        return parseFloat(String(totalPercentage)).toFixed(2);
    }
};
export const getRound = (num) => {
    if (Number.isInteger(num)) {
        // If it's an integer, return it as is
        return num;
    } else {
        // If it has decimal places, round it to 2 decimal places
        return parseFloat(String(num)).toFixed(2);
    }
};
export const round5 = (x) => {
    return x >= 0 ? Math.ceil(x / 5) * 5 : Math.floor(x / 5) * 5;
};

export const round10 = (x) => {
    return x >= 0 ? Math.ceil(x / 10) * 10 : Math.floor(x / 10) * 10;
};
export const isNegative = (x) => {
    return x < 0 ? true : false;
};
export const calculateTotalPage = (totalItems, pagePerItem) => Math.abs(Math.ceil(Math.abs(totalItems) / Math.abs(pagePerItem)));

export const calculatTotalItemsCurrent = (pagePerItem, currentPage) => Math.abs(Math.ceil(Math.abs(pagePerItem) * Math.abs(currentPage)));

export const bytesToMB = (bytes) => {
    return Math.floor(bytes / (1024 * 1024));
};
